<template>
  <div class="flex flex-wrap items-center gap-x-5 gap-y-2 mb-3">
    <div
      v-for="group in visibleGroups"
      :key="group.level"
      class="flex items-center gap-x-1.5"
    >
      <div class="font-secondary text-[13px] leading-[20px] text-gray-800">
        {{ group.label }} match:
      </div>

      <MatchTag
        v-for="entry in group.entries"
        :key="entry.number"
        :id="entry.number"
        :level="group.level"
        clickable
        :class="{
          'opacity-25': selectedNumber && selectedNumber !== entry.number,
        }"
        @click="emit('select', entry.number)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import MatchTag from './MatchTag.vue'
import { ScoreLevel } from '@/shared/graphql/router/graphql'
import { computed } from 'vue'

const props = defineProps<{
  entries: Array<{
    number: number
    level?: ScoreLevel | null
  }>
  selectedNumber?: number | null
}>()

const emit = defineEmits<{
  select: [number: number]
}>()

const groups = computed(() =>
  [
    { level: ScoreLevel.High, label: 'High' },
    { level: ScoreLevel.Medium, label: 'Medium' },
    { level: ScoreLevel.Low, label: 'Low' },
  ].map((group) => ({
    ...group,
    entries: props.entries.filter((entry) => entry.level === group.level),
  }))
)

const visibleGroups = computed(() =>
  groups.value.filter((group) => group.entries.length)
)
</script>
